export default __webpack_public_path__ + "static/media/IconToShip.f383a857.svg";